import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { CustomerAppConverter } from "../../utils/converter/customer-app-converter";
import { CheckUtils, CustomerAppsModel, EncryptStorageEvent } from "../..";
var CustomerAppProvider = /** @class */ (function () {
    function CustomerAppProvider(_model, _events) {
        this._model = _model;
        this._events = _events;
        this._ready = false;
        this.bind();
    }
    CustomerAppProvider.prototype.bind = function () {
        this._events.subscribe(EncryptStorageEvent.LOCAL_STORAGE_CREATED, function () {
            //this._model.clear(false, true);
        });
    };
    Object.defineProperty(CustomerAppProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    CustomerAppProvider.prototype.load = function (customerAppsApiData) {
        this._model.clear(false, true);
        if (!CheckUtils.isEmpty(customerAppsApiData)) {
            this._model.addAll(CustomerAppConverter.convertCustomerPortalsToVo(customerAppsApiData), false, true);
        }
        this._ready = true;
        this._events.publish(CustomerAppProviderEvent.READY);
    };
    Object.defineProperty(CustomerAppProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    CustomerAppProvider.prototype.getAllByType = function (type) {
        var result = [];
        for (var _i = 0, _a = this.model.getAll(); _i < _a.length; _i++) {
            var customerAppVo = _a[_i];
            if (customerAppVo.type === type)
                result.push(customerAppVo);
        }
        return result;
    };
    CustomerAppProvider.prototype.getOneByType = function (type) {
        var result = undefined;
        for (var _i = 0, _a = this.model.getAll(); _i < _a.length; _i++) {
            var customerAppVo = _a[_i];
            if (customerAppVo.type === type) {
                result = customerAppVo;
                break;
            }
        }
        return result;
    };
    CustomerAppProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    CustomerAppProvider.ctorParameters = function () { return [
        { type: CustomerAppsModel, },
        { type: Events, },
    ]; };
    return CustomerAppProvider;
}());
export { CustomerAppProvider };
export var CustomerAppProviderEvent;
(function (CustomerAppProviderEvent) {
    CustomerAppProviderEvent["READY"] = "customer-app-provider:ready";
})(CustomerAppProviderEvent || (CustomerAppProviderEvent = {}));
//# sourceMappingURL=customer-app-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/customer-apps/customer-app-provider.js
// module id = 385
// module chunks = 14